module.exports = __webpack_public_path__ + "static/media/printer.533942d5.svg";